import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { SESSION_FEATURE_KEY } from './keys';
import { sessionReducer } from './reducers/session.reducer';
import { SessionEffects } from './effects/session.effects';

export function provideSessionStore(): EnvironmentProviders[] {
    return [provideState(SESSION_FEATURE_KEY, sessionReducer), provideEffects(SessionEffects)];
}
